import { Card, CardBody, Col, Form, Input, Label } from "reactstrap";
import { P } from "../../../AbstractElements";
import { BorderRightTitle, EmailAddress } from "../../../Constants/Constants";
import { BorderRightSubTitle } from "../../../Data/BonusUi/CreativeCard";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BorderRight = () => {
  return (
    <Col md="6" xs="12">
      <Card>
        <CommonCardHeader title={BorderRightTitle} span={BorderRightSubTitle} headClass="border-r-secondary pb-0" />
        <CardBody>
          <P>{"You can design your creative card by taking only the "}<strong>{"border-l-primary "}</strong>{" class. If you want to use other colors like this: "}<strong>{"border-l-*"}</strong></P>
          <Form>
            <Label>{EmailAddress}</Label>
            <Input type="email" placeholder="youremail@gmail.com" />
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderRight;
